module.exports = __webpack_public_path__ + "img/ws.bd64ee69.png";